import { render, staticRenderFns } from "./CardListStockItems.vue?vue&type=template&id=30cbf9ce"
import script from "./CardListStockItems.vue?vue&type=script&lang=js"
export * from "./CardListStockItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30cbf9ce')) {
      api.createRecord('30cbf9ce', component.options)
    } else {
      api.reload('30cbf9ce', component.options)
    }
    module.hot.accept("./CardListStockItems.vue?vue&type=template&id=30cbf9ce", function () {
      api.rerender('30cbf9ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/CardListStockItems.vue"
export default component.exports